'use client';
import React__default, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button.js';
import Icon from '../../../Icon/index.js';
import { VARIANTS } from '../../../Icon/Icon.js';
import { BUTTON_TEXT_POSITION_MAP, BUTTON_ICON_SIZE, BUTTON_VARIANT, BUTTON_SHAPE } from '../Button.constants.js';
import { LOADING_ICON } from '../../../Icon/Icon.constants.js';
import deprecated from '../../../../utils/deprecated.js';
import ScreenReaderOnly from '../../../ScreenReaderOnly/index.js';

var defaultProps = {
  ariaLabel: undefined,
  as: 'button',
  children: undefined,
  disabled: false,
  displayText: BUTTON_TEXT_POSITION_MAP.HIDDEN,
  href: undefined,
  icon: VARIANTS[0],
  id: undefined,
  isPending: false,
  off: false,
  onClick: function onClick() {},
  size: BUTTON_ICON_SIZE.REGULAR,
  target: undefined,
  testId: undefined,
  title: undefined,
  typographyVariant: undefined,
  variant: BUTTON_VARIANT.PRIMARY
};
var ButtonIcon = forwardRef(function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultProps,
    ariaLabel = _ref.ariaLabel,
    as = _ref.as,
    children = _ref.children,
    disabled = _ref.disabled,
    displayText = _ref.displayText,
    href = _ref.href,
    icon = _ref.icon,
    id = _ref.id,
    _ref$isPending = _ref.isPending,
    isPending = _ref$isPending === void 0 ? false : _ref$isPending,
    off = _ref.off,
    onClick = _ref.onClick,
    size = _ref.size,
    target = _ref.target,
    testId = _ref.testId,
    title = _ref.title;
    _ref.typographyVariant;
    var variant = _ref.variant;
  var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var isHiddenText = displayText === BUTTON_TEXT_POSITION_MAP.HIDDEN;
  var iconSize = size === BUTTON_ICON_SIZE.LARGE ? BUTTON_ICON_SIZE.REGULAR : size;
  var iconVariant = isPending ? LOADING_ICON : icon;
  var iconComponent = React__default.createElement(Icon, {
    size: iconSize,
    variant: iconVariant,
    off: off
  });
  return React__default.createElement(Button, {
    ref: ref,
    ariaLabel: ariaLabel || children,
    as: as,
    href: href,
    id: id,
    isDisabled: disabled,
    onClick: onClick,
    shape: !isHiddenText ? BUTTON_SHAPE.PILL : BUTTON_SHAPE.CIRCLE,
    size: size,
    target: target,
    testId: testId,
    title: title,
    variant: variant
  }, (isHiddenText || displayText === BUTTON_TEXT_POSITION_MAP.RIGHT) && iconComponent, children && (isHiddenText ? React__default.createElement(ScreenReaderOnly, null, children) : React__default.createElement("div", null, children)), displayText === BUTTON_TEXT_POSITION_MAP.LEFT && iconComponent);
});
ButtonIcon.defaultProps = defaultProps;
ButtonIcon.propTypes = {
  ariaLabel: PropTypes.string,
  as: PropTypes.string,
  children: PropTypes.node,
  disabled: Button.propTypes.isDisabled,
  displayText: PropTypes.oneOf(Object.values(BUTTON_TEXT_POSITION_MAP)),
  href: PropTypes.string,
  icon: Icon.propTypes.variant,
  id: PropTypes.string,
  isPending: PropTypes.bool,
  off: PropTypes.bool,
  onClick: Button.propTypes.onClick,
  size: PropTypes.oneOf(Object.values(BUTTON_ICON_SIZE)),
  target: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  typographyVariant: deprecated(PropTypes.string, '2.19.1'),
  variant: Button.propTypes.variant
};
var ButtonIcon$1 = ButtonIcon;

export { ButtonIcon$1 as default };
//# sourceMappingURL=ButtonIcon.js.map
